.search {
    width: 160px;
}
